import { Button, Modal } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { IPomReportCategoryData } from '../util/DataModelInterface';
import { useEffect, useState } from 'react';
import { ToastWrap } from '../components/ToastWrap';

export interface ICategoryModalProps {
  active: boolean;
  modalId: string;
  onClose: () => void;
  title: string;
  confirmbutton: ICategoryModalButtonProps;
}

export interface ICategoryModalButtonProps {
  name: string;
  class: string;
  onClick: (d: any) => void;
}

export const CategoryModal  = (props: ICategoryModalProps) => {
  const intl = useIntl();

  const [toastActive, setToastActive] = useState(false);
  const [toastHeader, setToastHeader] = useState("");
  const [toastText, setToastText] = useState("");
  const [toastType, setToastType] = useState("");

  const [cat, setCat] = useState({} as IPomReportCategoryData);
  const [isFieldsEdited, setIsFieldsEdited] = useState(false);

  useEffect(() => {
    if (props.active) {
      setCat({} as IPomReportCategoryData);
      setIsFieldsEdited(false);
    }
  }, [props.active]);

  const validationRules: {[x:string]: boolean} = {
    code: !!cat.code && cat.code.match(/^ *$/) === null,
    name_fi: !!cat.name_fi && cat.name_fi.match(/^ *$/) === null,
    name_se: !!cat.name_se && cat.name_se.match(/^ *$/) === null,
    name_en: !!cat.name_en && cat.name_en.match(/^ *$/) === null,
  }


  const updateCat = (event: { currentTarget: any; }) => {
    const target = event.currentTarget;

    setCat({
      ...cat,
      [target.name]: target.type === 'checkbox'
          ? target.checked
          : target.value
    });
  }

  const handleSelect = () => {
    const isValidForm = Object
      .values(validationRules)
      .every(key => key);

    if (!isValidForm) {
      setIsFieldsEdited(true);
      // console.log('Not valid form');
      setToastHeader(intl.formatMessage({id: 'error.categories.add'}));
      setToastText(intl.formatMessage({id: 'companies.fail.info'}));
      setToastType('warning');
      setToastActive(true);
      return;
    }
    setIsFieldsEdited(false);
    props.confirmbutton.onClick(cat);
    handleClose();
  }

  const handleClose = () => {
    props.onClose();
  }

  const validate = (field: string) => {
    return ((isFieldsEdited && !validationRules[field]) ? 'has-error' : '')
  }

  return (
    <>
      <ToastWrap active={toastActive} heading={toastHeader} text={toastText} type={toastType} setActive={(active: boolean) => setToastActive(active)} />
      <Modal id={props.modalId} show={props.active} onHide={handleClose}>

      <Modal.Header>
        <h2>{props.title}</h2>
        <button type="button" className="btn btn-link p-3" onClick={handleClose} aria-label={ intl.formatMessage({ id: 'button.close' })}>
          <i aria-hidden="true" role="presentation" className="fa fa-remove"></i>
        </button>
      </Modal.Header>

      <Modal.Body>

        <div id="categorydetails">

          <div className={"form-group " + validate('code')}>

            <label htmlFor="code" className="form-label"><FormattedMessage id="categories.category.code"/></label>
            <input id="code" name="code" className="form-control" type="text"
                autoComplete="off" onChange={updateCat}
                value={cat.code ? cat.code : ""}/>
          </div>
          <div aria-atomic="true" aria-live="polite">
            <div className="field-error" id="test1" >
              <i className="fa fa-warning mr-2"></i>
              <FormattedMessage id='categories.obligatory.info'/>
            </div>
          </div>

          <div className={"form-group " + validate('name_fi')}>

            <label htmlFor="name_fi" className="form-label"><FormattedMessage id='categories.category.name_fi'/></label>
            <input id="name_fi" name="name_fi" className="form-control" type="text"
                autoComplete="off" onChange={updateCat} aria-label={intl.formatMessage({id: 'categories.category.name_fi'})}
                value={cat.name_fi ? cat.name_fi : ""}/>
          </div>
          <div aria-atomic="true" aria-live="polite">
            <div className="field-error" id="test1" >
              <i className="fa fa-warning mr-2"></i>
              <FormattedMessage id='categories.obligatory.info'/>
            </div>
          </div>

          <div className={"form-group " + validate('name_se')}>

            <label htmlFor="name_se" className="form-label"><FormattedMessage id='categories.category.name_se'/></label>
            <input id="name_se" name="name_se" className="form-control" type="text"
                autoComplete="off" onChange={updateCat} aria-label={intl.formatMessage({id: 'categories.category.name_se'})}
                value={cat.name_se ? cat.name_se : ""}/>
          </div>
          <div aria-atomic="true" aria-live="polite">
            <div className="field-error" id="test1" >
              <i className="fa fa-warning mr-2"></i>
              <FormattedMessage id='categories.obligatory.info'/>
            </div>
          </div>

          <div className={"form-group " + validate('name_en')}>

            <label htmlFor="name_en" className="form-label"><FormattedMessage id='categories.category.name_en'/></label>
            <input id="name_en" name="name_en" className="form-control" type="text"
                autoComplete="off" onChange={updateCat} aria-label={intl.formatMessage({id: 'categories.category.name_en'})}
                value={cat.name_en ? cat.name_en : ""}/>
          </div>
          <div aria-atomic="true" aria-live="polite">
            <div className="field-error" id="test1" >
              <i className="fa fa-warning mr-2"></i>
              <FormattedMessage id='categories.obligatory.info'/>
            </div>
          </div>
        </div>

      </Modal.Body>

      <Modal.Footer>
        
        <Button className="btn btn-secondary" onClick={handleClose}>
          <FormattedMessage id="button.close"/>
        </Button>
        <Button className={props.confirmbutton.class} onClick={handleSelect}>
          {props.confirmbutton.name}
        </Button>
      </Modal.Footer>
      </Modal>

    </>
  );
}
